module.exports = __webpack_public_path__ + "img/组 12924.b4fb648b.png";